import { http } from '@/app/lib/http/client'

export interface WbsProduct {
  carrier_id: string
  description: string
  group: string
  amount: string
  note: string
  order: number
  check_amount: boolean
}

export interface WbsProductsResponse {
  data: {
    data: WbsProduct[]
    total: number
    per_page: number
    current_page: number
    last_page: number
  }
  message: string
}

export interface WbsBalanceData {
  Confirmation: string
  Saldo_Inicial: string
  Compras: string
  Ventas: string
  Comision: string
  Balance: string
}

export interface WbsBalanceResponse {
  data: WbsBalanceData
  message: string
}

export const wbsService = {
  testConnection: async (credentials?: any) => {
    const response = await http.post('/integrations/wbs/test-connection', credentials)
    return response.data
  },

  getBalance: async (): Promise<WbsBalanceResponse> => {
    const response = await http.get('/integrations/wbs/balance')
    return response.data
  },

  getProducts: async (params?: { search?: string; page?: number; per_page?: number }): Promise<WbsProductsResponse> => {
    const response = await http.get('/integrations/wbs/products', { params })
    return response.data
  },

  initiateTransaction: async (data: {
    type: 'RECHARGE' | 'SERVICE_PAYMENT',
    carrier_id: string,
    amount: string,
    reference: string,
    payment_method: string,
    sucursal_id: number
  }) => {
    const response = await http.post('/integrations/wbs/transactions', data)
    return response.data
  },

  checkStatus: async (folio: string) => {
    const response = await http.get(`/integrations/wbs/transactions/${folio}/status`)
    return response.data
  },

  checkDebt: async (data: { carrier_id: string, reference: string }) => {
    const response = await http.post('/integrations/wbs/debt', data)
    return response.data
  },

  getTransactions: async (params?: { search?: string; page?: number; per_page?: number }) => {
    const response = await http.get('/integrations/wbs/transactions', { params })
    return response.data
  }
}

